export const CLASS_TAG_TYPES = [
  { label: 'Default', value: 'Default' },
  { label: 'Inverted Modal', value: 'Inverted Modal' },
  { label: 'Live Assisted', value: 'Live Assisted' },
];
